import "./styles/estyle.css";
import { E400, E401, E403, E404, E405, E408, E500, E502, E503, E504 } from "./pages"

const errorPages = [E401, E404, E405, E408, E500, E502, E503, E504];
const RandomError = errorPages[Math.floor(Math.random() * errorPages.length)];

const pathname = window.location.pathname.toLowerCase();
const authKeywords = ["login", "register", "auth", "signup", "signin", "forgot", "password"];

function Main() {
    if (pathname !== "/") {
        if (authKeywords.some(keyword => pathname.includes(keyword))) {
            return <E403 />;
        }
        return <E400 />;
    }

    return <RandomError />;
}

export default Main;